import { Alert, Box, Link, Text } from '@nimbus-ds/components';
import { Trans } from 'react-i18next';
import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { useDismissibleComponent } from 'commons/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';
import {
  trackingNuvemEnvioCustomOrderBannerClick,
  trackingNuvemEnvioCustomOrderBannerClose,
} from 'domains/NuvemEnvioCommons/tracking';

const CUSTOM_ORDER_BANNER_DISMISS_KEY = 'custom-order-banner-dismiss';

const CUSTOM_ORDER_BANNER_URL = {
  [Country.MX]:
    'https://ayuda.tiendanube.com/es_MX/%C2%BFcomo-gestionar-envios-personalizados-en-envio-nube',
};

function CustomOrderBanner() {
  const t = useNuvemEnvioTranslations();
  const country = useGetCountry();

  const { shouldShow, dismiss } = useDismissibleComponent(
    CUSTOM_ORDER_BANNER_DISMISS_KEY,
    90,
  );

  const handleClose = () => {
    trackingNuvemEnvioCustomOrderBannerClose();
    dismiss();
  };

  const showButton = !!CUSTOM_ORDER_BANNER_URL[country];

  if (!shouldShow) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.MX, Country.BR]}>
      <Box pl="4" pr="4">
        <Alert appearance="primary" onRemove={handleClose}>
          <Box display="flex" flexDirection="column" gap="2">
            <Text color="primary-textLow">
              <Trans
                t={t}
                i18nKey="shipping.banners.customOrder.title"
                components={{ bold: <strong /> }}
              />
            </Text>
            {showButton && (
              <Link
                as="a"
                target="_blank"
                href={CUSTOM_ORDER_BANNER_URL[country]}
                rel="noopener noreferrer"
                onClick={trackingNuvemEnvioCustomOrderBannerClick}
              >
                {t('shipping.banners.customOrder.button')}
              </Link>
            )}
          </Box>
        </Alert>
      </Box>
    </ShowByCountry>
  );
}

export default CustomOrderBanner;
